"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTagsFilter = exports.getStatusesFilter = exports.getOrganizationsFilter = exports.getCategoriesFilter = exports.getAssetTypesFilter = exports.CUSTOM_FIELDS_TYPES_LABEL = exports.CUSTOM_FIELDS_OPERATORS_MAPPING = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("../CustomFieldsFilter/types");
var _types2 = require("../types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getAssetTypesFilter = ({
  assetTypesConfiguration,
  featureFlags,
  types,
  fixedTypes
}) => Object.keys(assetTypesConfiguration).reduce((accum, typeKey) => {
  const type = assetTypesConfiguration[typeKey];
  if (!(type !== null && type !== void 0 && type.filter)) {
    return accum;
  }
  if ((fixedTypes === null || fixedTypes === void 0 ? void 0 : fixedTypes.length) > 0 && !fixedTypes.includes(typeKey)) {
    return accum;
  }
  if ((types === null || types === void 0 ? void 0 : types.length) > 0 && !types.some($type => $type === assetTypesConfiguration[typeKey].angType)) {
    return accum;
  }
  if (typeKey === 'default') {
    return accum;
  }
  if (type.featureFlag && !(featureFlags !== null && featureFlags !== void 0 && featureFlags[type.featureFlag])) {
    return accum;
  }
  const typeItem = {
    k: type.angType,
    l: type.filter
  };
  if (accum.some(item => item.l === typeItem.l && item.k === typeItem.k)) {
    return accum;
  }
  return [...accum, typeItem];
}, []);
exports.getAssetTypesFilter = getAssetTypesFilter;
const getCategoriesFilter = categories => (categories !== null && categories !== void 0 ? categories : []).map(({
  displayName,
  tagKey,
  value
}) => ({
  g: displayName,
  k: `${tagKey}:${value}`,
  l: value
}));
exports.getCategoriesFilter = getCategoriesFilter;
const getTagsFilter = tags => (tags !== null && tags !== void 0 ? tags : []).map(tag => ({
  l: tag,
  k: tag
}));
exports.getTagsFilter = getTagsFilter;
const getStatusLabel = status => {
  const label = status === 'published' ? 'stable' : status;
  return label[0].toUpperCase() + label.substring(1);
};
const getStatusesFilter = statuses => (statuses !== null && statuses !== void 0 ? statuses : []).map(status => ({
  l: getStatusLabel(status),
  k: status
}));
exports.getStatusesFilter = getStatusesFilter;
const getOrganizationsFilter = (organizations, config, profile, angQuery) => {
  var _angQuery$organizatio;
  const facetsOrganizations = (organizations !== null && organizations !== void 0 ? organizations : []).reduce((accum, organization) => {
    var _profile$organization, _profile$organization2;
    const isExternal = !profile ? false : profile.memberOfOrganizations.every(orgMember => orgMember.id !== organization.id);
    return [...accum, _objectSpread(_objectSpread({}, organization), {}, {
      group: isExternal ? 'External' : (_profile$organization = profile === null || profile === void 0 || (_profile$organization2 = profile.organization) === null || _profile$organization2 === void 0 ? void 0 : _profile$organization2.name) !== null && _profile$organization !== void 0 ? _profile$organization : 'User organizations',
      isExternal
    })];
  }, []).sort((orgA, orgB) => {
    if (orgA.isExternal === orgB.isExternal) {
      return orgA.name.localeCompare(orgB.name);
    }
    if (orgA.isExternal) {
      return 1;
    }
    return -1;
  }).map(organization => {
    var _config$mulesoft;
    let organizationName;
    if (organization.id === ((_config$mulesoft = config.mulesoft) === null || _config$mulesoft === void 0 ? void 0 : _config$mulesoft.id)) {
      organizationName = `Provided by MuleSoft`;
    } else if (organization.isMaster) {
      organizationName = `${organization.name} (root)`;
    } else {
      organizationName = organization.name;
    }
    return {
      l: organizationName,
      g: organization.group,
      k: organization.id
    };
  });
  ((_angQuery$organizatio = angQuery.organizationId) !== null && _angQuery$organizatio !== void 0 ? _angQuery$organizatio : []).forEach(organizationId => {
    if (facetsOrganizations.every(organization => organization.k !== organizationId)) {
      facetsOrganizations.push({
        l: '...',
        k: organizationId,
        g: '...'
      });
    }
  });
  return facetsOrganizations;
};
exports.getOrganizationsFilter = getOrganizationsFilter;
const CUSTOM_FIELDS_OPERATORS_MAPPING = exports.CUSTOM_FIELDS_OPERATORS_MAPPING = {
  [_types2.FacetsCustomFieldType.Date]: [_types.CustomFieldOperator.Equals, _types.CustomFieldOperator.GreaterThan, _types.CustomFieldOperator.GreaterThanOrEqual, _types.CustomFieldOperator.LessThan, _types.CustomFieldOperator.LessThanOrEqual
  // not adding "not equals" operator since not possible to implement using dates without hour+minute
  ],
  [_types2.FacetsCustomFieldType.Enum]: [_types.CustomFieldOperator.Contains, _types.CustomFieldOperator.NotContains],
  [_types2.FacetsCustomFieldType.ListOfNumbers]: [_types.CustomFieldOperator.Contains, _types.CustomFieldOperator.NotContains],
  [_types2.FacetsCustomFieldType.ListOfTexts]: [_types.CustomFieldOperator.Contains, _types.CustomFieldOperator.NotContains],
  [_types2.FacetsCustomFieldType.Number]: [_types.CustomFieldOperator.Equals, _types.CustomFieldOperator.GreaterThan, _types.CustomFieldOperator.GreaterThanOrEqual, _types.CustomFieldOperator.LessThan, _types.CustomFieldOperator.LessThanOrEqual, _types.CustomFieldOperator.NotEquals],
  [_types2.FacetsCustomFieldType.Text]: [_types.CustomFieldOperator.Equals, _types.CustomFieldOperator.NotEquals]
};
const CUSTOM_FIELDS_TYPES_LABEL = exports.CUSTOM_FIELDS_TYPES_LABEL = {
  [_types2.FacetsCustomFieldType.Date]: 'Date',
  [_types2.FacetsCustomFieldType.Enum]: 'Enum',
  [_types2.FacetsCustomFieldType.Number]: 'Number',
  [_types2.FacetsCustomFieldType.ListOfNumbers]: 'List of numbers',
  [_types2.FacetsCustomFieldType.Text]: 'Text',
  [_types2.FacetsCustomFieldType.ListOfTexts]: 'List of strings'
};
//# sourceMappingURL=filters.js.map